import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.base`;
export const INIT = `${SCOPE}/INIT`;
export const SET_MODE = `${SCOPE}/SET_MODE`;
export const SET_SORT = `${SCOPE}/SET_SORT`;
export const CHANGE_WARNING_CONTAINER_VISIBILITY = `${SCOPE}/CHANGE_WARNING_CONTAINER_VISIBILITY`;
export const CHANGE_ENABLE_PARTNER_MODAL_VISIBILITY = `${SCOPE}/CHANGE_ENABLE_PARTNER_MODAL_VISIBILITY`;
